<template>
<p class="link-academic">To preview the Academic Specialties of your choice, begin typing the name of the academics you are interested in and a list of options will appear. Click <a @click="goToLink()"><b><u>Here</u></b></a> to view the list of Academic Specialties offered by colleges.
</p>
</template>

<script>

export default {
  name: "Par",
  props: {
    msg: String
  },
  methods:{
    goToLink(){
      const profile_id = localStorage.getItem('profile-id')
         const newWindow = window.open(
          `${window.location.origin}/${profile_id}/academic-specialties-list`
        )
    }
  }
};
</script>
<style lang="scss">
.link-academic{
  text-align:center;
  grid-column-start: 2 !important;
  grid-column-end: 10 !important;
  grid-row-start: 4 !important;
}
</style>